import { Vector, isclose, clip, dot, cross } from "./math.js";
import { Edge, Polygon, NavMesh } from "./navmesh.js";

const Point = Vector;

export { Point, Vector, isclose, clip, dot, cross, Edge, Polygon, NavMesh };
